// extracted by mini-css-extract-plugin
export default {"dragBox":"DragNDrop_dragBox__WPE66","dndBox":"DragNDrop_dndBox__jSkAh"};